
export const selectText = (node: HTMLElement) => {
    let range = null;
    let selection = null;
    if (window.getSelection) {
        selection = window.getSelection()!;
        range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    return selection;
};